<section class="support-container bolt-container">

    <!-- Loading State -->
    <div *ngIf="supportState === SupportStateEnum.LOADING" class="bolt-text-align-center">
        <bolt-waiting-indicator class="bolt-space-inner-xl bolt-space-bottom-lg">Loading support information...</bolt-waiting-indicator>
    </div>

    <!-- Error State -->
    <bolt-notification  *ngIf="supportState === SupportStateEnum.ERROR"  type="error" class="bolt-space-bottom-lg">
        Your claim support details didn't load. We'll get it fixed.
    </bolt-notification>

    <!-- Has Data State -->
    <div *ngIf="supportState === SupportStateEnum.HAS_DATA">

        <div class="support-section  bolt-space-bottom-2xl">
            <div class="bolt-heading-md bolt-space-bottom-lg">Support</div>
            <div class="bolt-space-bottom-xl">
                <div class="note-input-container">
                    <bolt-textarea
                        [(ngModel)]="noteText"
                        label="Enter any new information about your claim here, and we’ll add it to your file."
                        [maxlength]="MAX_NOTE_LENGTH"
                        showcount
                        rows="5"
                        optionaltext="hide"
                        [disabled]="noteSending">
                    </bolt-textarea>
                    <div class="bolt-space-top-sm bolt-space-bottom-md bolt-justify-content-end" style="display: flex;">
                        <bolt-button
                            type="primary"
                            (click)="sendNote()"
                            [attr.disabled]="!noteText.trim() || noteSending ? true : null">
                            <span *ngIf="!noteSending">Send</span>
                            <span *ngIf="noteSending">Sending...</span>
                        </bolt-button>
                    </div>

                    <!-- Success Message -->
                    <bolt-notification *ngIf="noteSuccess" type="success" >
                        Your note has been added to the claim successfully.
                    </bolt-notification>

                    <!-- Error Message -->
                    <bolt-notification *ngIf="noteError" type="error" class="bolt-space-bottom-2xl" [innerHTML]="noteError">
                    </bolt-notification>
                </div>
            </div>
        </div>

        <div class="contact-section  bolt-space-bottom-2xl">
            <div class="bolt-heading-md bolt-space-bottom-lg">Contact us</div>
            <div class="bolt-body-md bolt-color-text-darkGray bolt-space-bottom-lg">
                Questions? Reach out to your claims professional with questions about your claim, or your agent with general questions about your policy. This was your agent at the time the claim was filed.
            </div>
            <div class="bolt-row bolt-space-bottom-lg">
                <!-- Adjuster Section -->
                <div *ngIf="adjuster" class="bolt-col-xs-12 bolt-col-md-6 adjuster-section  bolt-space-bottom-md">
                    <div class="contact-name bolt-heading-xs">
                        <span class="contact-label">Claims professional: </span>{{ adjuster.displayName }}
                    </div>
                    <div>
                        <strong class="phone-label bolt-body-lg">
                            <span class="desktop-only">Phone number: </span>
                            <span class="mobile-only">Phone: </span>
                        </strong>
                        <a href="tel:{{ adjuster.phoneNumber }}" class="bolt-link phone-link bolt-body-lg">
                            {{ adjuster.phoneNumber | phoneFormat }}
                        </a>
                    </div>
                    <div *ngIf="adjuster.email">
                        <strong class="bolt-body-lg">Email: </strong>
                        <a [href]="'mailto:' + adjuster.email" class="bolt-link bolt-body-lg">
                            {{ adjuster.email }}
                        </a>
                    </div>
                </div>

                <!-- Agent Section -->
                <div *ngIf="agent" class="bolt-col-xs-12 bolt-col-md-6">
                    <div class="contact-name bolt-heading-xs">
                        <span class="contact-label">Agent: </span>{{ agent.displayName | titlecase }}
                    </div>
                    <div *ngIf="agent.phoneNumber">
                        <strong class="phone-label bolt-body-lg">
                            <span class="desktop-only">Phone number: </span>
                            <span class="mobile-only">Phone: </span>
                        </strong>
                        <a href="tel:{{ agent.phoneNumber }}" class="bolt-link phone-link bolt-body-lg">
                            {{ agent.phoneNumber | phoneFormat }}
                        </a>
                    </div>
                    <div *ngIf="agent.email">
                        <strong class="bolt-body-lg">Email: </strong>
                        <a [href]="'mailto:' + agent.email" class="bolt-link bolt-body-lg">
                            {{ agent.email }}
                        </a>
                    </div>
                </div>
            </div>
        </div>


        <div  class="faq-section  bolt-space-bottom-2xl">
            <bolt-accordion-group header="FAQ" showtoggle>
                <bolt-accordion header="What happens after I report a claim?">
                    <div class="bolt-space-inner-md">
                        <p class="bolt-body-lg bolt-space-bottom-md">
                            A claims professional will be assigned to review your claim and follow up if more information is needed. Your property may need to be inspected to evaluate the loss and estimate damages.
                        </p>
                        <p class="bolt-body-lg">
                            You can track the progress of your claim by logging in to your account, or by contacting your claims professional directly.
                        </p>
                    </div>
                </bolt-accordion>

                <bolt-accordion header="How can I get my property fixed?">
                    <div class="bolt-space-inner-md">
                        <p class="bolt-body-lg bolt-space-bottom-md">
                            You can pick your own contractor. Or we offer options to help you get an estimate and complete repairs.
                        </p>
                        <p class="bolt-body-lg">
                            An On Your Side Property Repair Network®  contractor can perform the repairs. Their workmanship is  guaranteed for five years from the date of the completed repairs, as long as you own the house they repair. This guarantee is not transferable.*
                        </p>
                    </div>
                </bolt-accordion>

                <bolt-accordion header="What is a deductible?">
                    <div class="bolt-space-inner-md">
                        <p class="bolt-body-lg">
                            The deductible is the dollar amount you have to pay for the damage/loss. Your deductible amount can be found on the insurance declarations page. Our online insurance glossary can help you make sense of this and other insurance terms.
                        </p>
                    </div>
                </bolt-accordion>

                <bolt-accordion header="How is my estimate determined?">
                    <div class="bolt-space-inner-md">
                        <p class="bolt-body-lg">
                            Your estimate is determined by using local market rates for labor and materials. If there is additional damage to your property, or you have questions about your estimate, contact your claims professional.
                        </p>
                    </div>
                </bolt-accordion>

                <bolt-accordion header="How do I read my estimate?">
                    <div class="bolt-space-inner-md">
                        <p class="bolt-body-lg">
                            <a class="bolt-link bolt-body-lg" href='assets/pdf/estimate.pdf' target="_blank">Learn how to read your estimate.</a>
                        </p>
                    </div>
                </bolt-accordion>

                <bolt-accordion header="How will payment be made for damages to my property?">
                    <div class="bolt-space-inner-md">
                        <p class="bolt-body-lg">
                            For covered damages, we'll either issue payment to the On Your Side Property Repair Network contractor, to you directly or to both you and the contractor. The payment will be the amount of damage minus your deductible. If you have a mortgage on your property, the mortgage company may be included on the payment.
                        </p>
                    </div>
                </bolt-accordion>

                <bolt-accordion header="Why is my mortgage company's name on my settlement checks?">
                    <div class="bolt-space-inner-md">
                        <p class="bolt-body-lg">
                            Since your mortgage company has an interest in seeing your property repaired, we may be required to include the company on your settlement checks. Ask your mortgage company how they'll handle the processing of the check.
                        </p>
                    </div>
                </bolt-accordion>

                <bolt-accordion header="Will filing a claim affect my homeowner's insurance rates?">
                    <div class="bolt-space-inner-md">
                        <p class="bolt-body-lg">
                            Past claim payment is one of many factors that could impact your insurance rate. Whether a claim payment will affect your rate depends on various factors, including the type of claim. Please contact your agent to discuss your insurance rate questions.
                        </p>
                    </div>
                </bolt-accordion>

                <bolt-accordion header="How long will my repairs take?">
                    <div class="bolt-space-inner-md">
                        <p class="bolt-body-lg">
                            Every situation is different. Your claims professional will evaluate your damage and work with the contractor or service provider you chose to determine a timeline.
                        </p>
                    </div>
                </bolt-accordion>

                <bolt-accordion header="Why can't I upload a photo or document to my claim?">
                    <div class="bolt-space-inner-md">
                        <p class="bolt-body-lg bolt-space-bottom-sm">Reasons could include:</p>
                        <ul class="faq-list bolt-body-lg">
                            <li>File size: File can't be larger than 10 MB</li>
                            <li>File name: Remove any special characters such as , * [ ] or _ in the file name</li>
                            <li>File type: Check what type of file you have. We accept the following types: PDF, JPEG, GIF, TIFF, PNG, BMP, DOC, DOCX, XLS, XLSX</li>
                            <li>Corrupt file: Check your file and try again</li>
                            <li>Maximum number reached: We can only accept 20 total documents or photos for a claim. Please direct any additional documents to your claims professional</li>
                            <li>Page refreshed or closed: Make sure you don't navigate away, refresh or close the page while you're uploading</li>
                            <li>Technical issues: Our system could be having problems, so please try again later</li>
                        </ul>
                        <p class="bolt-body-lg bolt-space-top-md">
                            If you can't upload photos or documents, email them to your claims professional.
                        </p>
                        <p class="bolt-body-lg">
                            Please include your claim number on each photo or document you send.
                        </p>
                    </div>
                </bolt-accordion>
            </bolt-accordion-group>
        </div>


        <div  class="disclaimer-section  bolt-space-bottom-2xl">
            <p class="bolt-body-lg">
                Insurance terms, definitions and explanations are intended for informational purposes only and do not in any way replace or modify the definitions and information contained in individual insurance contracts, policies or declaration pages, which control coverage determinations. Such terms may vary by state, and exclusions may apply. Discounts may not be applied to all policy coverages.
            </p>
        </div>

        <div  class="fraud-section  bolt-space-bottom-2xl" *ngIf="fraudLanguage">
                <p class="bolt-body-lg">
                    {{ fraudLanguage }}
                </p>
        </div>


    </div>
</section>

